import Collection from '../collections/Collection'
import Leaderboard from '../leaderboard/Leaderboard'
import MissionDayOne from '../missions/MissionDayOne'
import MissionDayThree from '../missions/MissionDayThree'
import MissionDayTwo from '../missions/MissionDayTwo'
import MyStats from '../stats/MyStats'

export const SliderContent = ({ component, civilisation }) => {
  switch (component) {
    case 'collection':
      return <Collection className="collection" collection={civilisation} />
    case 'missionDayOne':
      return <MissionDayOne civilisation={civilisation} />
    case 'missionDayTwo':
      return <MissionDayTwo civilisation={civilisation} />
    case 'missionDayThree':
      return <MissionDayThree civilisation={civilisation} />
    case 'myStats':
      return <MyStats civilisation={civilisation} />
    case 'leaderboard':
      return <Leaderboard civilisation={civilisation} />
    default:
      break
  }
}
